// Started from: https://codepen.io/gregh/pen/NdVvbm

const audioPlayers = document.querySelectorAll('.js-audio');

export default function audioplayer() {
    audioPlayers.forEach((audioplayerNode) => {

        let currentPlayer;

        let loading;
        let playPause;
        let playpauseBtn;

        let progress;
        let sliders;

        let volumeControls;
        let volumeProgress;
        let speaker;

        let currentTime;

        let player;

        let draggableClasses;
        let currentlyDragged = null;

        let sliderListeners;

        currentPlayer = audioplayerNode;
        loading = audioplayerNode.querySelector('.js-audio-loading');
        playPause = audioplayerNode.querySelector('.js-playPause');
        playpauseBtn = audioplayerNode.querySelector('.js-audio-btn');

        progress = audioplayerNode.querySelector('.js-audio-progress');
        sliders = audioplayerNode.querySelectorAll('.js-audio-slider');

        volumeControls = audioplayerNode.querySelector('.js-audio-volume-controls');
        volumeProgress = volumeControls.querySelector(
            '.js-audio-slider .js-audio-progress'
        );
        speaker = audioplayerNode.querySelector('.js-audio-speaker');

        currentTime = audioplayerNode.querySelector('.js-audio-current-time');

        player = audioplayerNode.querySelector('audio');

        draggableClasses = ['js-pin'];

        sliderListeners = {
            rewind,
            changeVolume
        };

        window.addEventListener('mousedown', mouseEventHandler);

        playpauseBtn.addEventListener('click', togglePlay);
        player.addEventListener('timeupdate', updateProgress);
        player.addEventListener('volumechange', updateVolume);
        player.addEventListener('loadedmetadata', () => {
            currentTime.textContent = formatTime(player.duration);
        });

        makePlay();

        player.addEventListener('ended', () => {
            // eslint-disable-next-line max-len
            playPause.attributes.d.value = 'M0 7.667v8h5.333L12 22.333V1L5.333 7.667M17.333 11.373C17.333 9.013 16 6.987 14 6v10.707c2-.947 3.333-2.987 3.333-5.334z';
            player.currentTime = 0;
        });

        window.addEventListener('resize', directionAware);

        sliders.forEach((slider) => {
            const pin = slider.querySelector('.js-pin');
            slider.addEventListener('click', sliderListeners[pin.dataset.method]);
        });

        directionAware();

        function mouseEventHandler(event) {
            if (!isDraggable(event.target)) return;

            currentlyDragged = event.target;
            const handleMethod = currentlyDragged.dataset.method;

            this.addEventListener('mousemove', sliderListeners[handleMethod], false);

            window.addEventListener(
                'mouseup',
                () => {
                    currentlyDragged = false;
                    window.removeEventListener(
                        'mousemove',
                        sliderListeners[handleMethod],
                        false
                    );
                },
                false
            );
        }

        function isDraggable(el) {
            let canDrag = false;
            const classes = Array.from(el.classList);
            draggableClasses.forEach((draggable) => {
                if (classes.indexOf(draggable) !== -1) canDrag = true;
            });
            return canDrag;
        }

        function inRange(event) {
            const rangeBox = getRangeBox(event);
            const rect = rangeBox.getBoundingClientRect();
            const direction = rangeBox.dataset.direction;
            if (direction === 'horizontal') {
                const min = rangeBox.offsetLeft;
                const max = min + rangeBox.offsetWidth;
                if (event.clientX < min || event.clientX > max) return false;
            } else {
                const min = rect.top;
                const max = min + rangeBox.offsetHeight;
                if (event.clientY < min || event.clientY > max) return false;
            }
            return true;
        }

        function updateProgress() {
            const current = player.currentTime;
            const percent = (current / player.duration) * 100;
            progress.style.width = `${percent}%`;

            currentTime.textContent = formatTime(player.duration - current);
        }

        function updateVolume() {
            volumeProgress.style.width = `calc(${player.volume}% * 100)`;
            if (player.volume >= 0.5) {
                speaker.attributes.d.value =
                    // eslint-disable-next-line max-len
                    'M14.667 0v2.747c3.853 1.146 6.666 4.72 6.666 8.946 0 4.227-2.813 7.787-6.666 8.934v2.76C20 22.173 24 17.4 24 11.693 24 5.987 20 1.213 14.667 0zM18 11.693c0-2.36-1.333-4.386-3.333-5.373v10.707c2-.947 3.333-2.987 3.333-5.334zm-18-4v8h5.333L12 22.36V1.027L5.333 7.693H0z';
            } else if (player.volume < 0.5 && player.volume > 0.05) {
                speaker.attributes.d.value =
                    // eslint-disable-next-line max-len
                    'M0 7.667v8h5.333L12 22.333V1L5.333 7.667M17.333 11.373C17.333 9.013 16 6.987 14 6v10.707c2-.947 3.333-2.987 3.333-5.334z';
            } else if (player.volume <= 0.05) {
                speaker.attributes.d.value = 'M0 7.667v8h5.333L12 22.333V1L5.333 7.667';
            }
        }

        function getRangeBox(event) {
            let rangeBox = event.target;
            const el = currentlyDragged;
            if (event.type === 'click' && isDraggable(event.target)) {
                rangeBox = event.target.parentElement.parentElement;
            }
            if (event.type === 'mousemove') {
                rangeBox = el.parentElement.parentElement;
            }
            return rangeBox;
        }

        function getCoefficient(event) {
            const slider = getRangeBox(event);
            const rect = slider.getBoundingClientRect();
            let K = 0;
            if (slider.dataset.direction === 'horizontal') {
                const offsetX = event.clientX - slider.offsetLeft;
                const width = slider.clientWidth;
                K = offsetX / width;
            } else if (slider.dataset.direction === 'vertical') {
                const height = slider.clientHeight;
                const offsetY = event.clientY - rect.top;
                K = 1 - (offsetY / height);
            }
            return K;
        }

        function rewind(event) {
            if (inRange(event)) {
                player.currentTime = player.duration * getCoefficient(event);
            }
        }

        function changeVolume(event) {
            if (inRange(event)) {
                player.volume = getCoefficient(event);
            }
        }


        function togglePlay() {
            if (player.paused) {
                // eslint-disable-next-line max-len
                playPause.attributes.d.value = 'M2,0 C3.1045695,-2.02906125e-16 4,0.8954305 4,2 L4,16 C4,17.1045695 3.1045695,18 2,18 C0.8954305,18 1.3527075e-16,17.1045695 0,16 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z M10,0 C11.1045695,-2.02906125e-16 12,0.8954305 12,2 L12,16 C12,17.1045695 11.1045695,18 10,18 C8.8954305,18 8,17.1045695 8,16 L8,2 C8,0.8954305 8.8954305,2.02906125e-16 10,0 Z';
                player.play();
            } else {
                // eslint-disable-next-line max-len
                playPause.attributes.d.value = 'M13.6807991,7.63444131 L2.36537181,0.24044061 C1.34250832,-0.42568558 0,0.373665848 0,1.63930561 L0,16.3606944 C0,17.6263342 1.34250832,18.4256856 2.36537181,17.7595594 L13.6807991,10.3655587 C14.6397336,9.76604512 14.6397336,8.3005675 13.6807991,7.63444131 Z';
                player.pause();
            }
        }

        function makePlay() {
            playpauseBtn.style.display = 'block';
            loading.style.display = 'none';
        }

        function directionAware() {
            if (window.innerHeight < 250) {
                volumeControls.style.bottom = '-54px';
                volumeControls.style.left = '54px';
            } else if (currentPlayer.offsetTop < 154) {
                volumeControls.style.bottom = '-164px';
                volumeControls.style.left = '-3px';
            } else {
                volumeControls.style.bottom = '52px';
                volumeControls.style.left = '-3px';
            }
        }
    });
}

function formatTime(time) {
    const min = Math.floor(time / 60);
    const sec = Math.floor(time % 60);

    const duration = pad(sec < 10 ? 0 + sec : sec, 2);
    return `${min}:${duration}`;
}

function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}






// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/audioplayer.js